import React from "react";
import "./App.css";
import Footer from "./common_components/Footer";
import firebase from "./FirebaseAuth.js";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home/Home";
import AboutUs from "./pages/about/AboutUs";
import Contact from "./pages/contact/Contact";
import Query from "./pages/More/Query";
import Atf from "./pages/More/Atf";
import Mc from "./pages/More/Mc";
import AboutVita from "./pages/Aboutvita/AboutVita";
import Gallery from "./pages/gallery/Gallery";
import RegisterPage from "./pages/register/RegisterPage";
import LoginPage from "./pages/login/LoginPage";
import ResetPassword from "./pages/resetPassword/ResetPassword";
import NewLoginPage from "./pages/newLoginPage/NewLoginPage";
import NotFound from "./pages/NotFound/notFound";
import Login from "./pages/login/Login";

function App() {
  return (
    <div>
      <BrowserRouter>
      <Routes>
      <Route path="/" element={<Home />}>
          <Route index element={<Home />} />
        </Route>
        <Route path="/about" element={<AboutUs />}>
          <Route element={<AboutUs />} />
        </Route>
        <Route path="/contact" element={<Contact />}>
          <Route element={<Contact />} />
        </Route>
        <Route path="/query" element={<Query />}>
          <Route element={<Query />} />
        </Route>
        <Route path="/atf" element={<Atf />}>
          <Route element={<Atf />} />
        </Route>
        <Route path="/migration_certificate" element={<Mc />}>
          <Route element={<Mc />} />
        </Route>
        <Route path="/about_vitaa" element={<AboutVita />}>
          <Route element={<AboutVita />} />
        </Route>
        <Route path="/gallery" element={<Gallery />}>
          <Route element={<Gallery />} />
        </Route>
        <Route path="/register" element={<RegisterPage />}>
          <Route element={<RegisterPage />} />
        </Route>
        <Route path="/login" element={<Login />}>
          <Route element={<Login />} />
        </Route>
        <Route path="/resetPassword" element={<ResetPassword />}>
          <Route element={<ResetPassword />} />
        </Route>
        {/* <Route path="/newLoginPage" element={<NewLoginPage />}>
          <Route element={<NewLoginPage />} />
        </Route>

        <Route path="/newRegistrationPage" element={<NewRegistrationPage />}>
          <Route element={<NewRegistrationPage />} />
        </Route> */}

        <Route path="*" element={<NotFound />}>
          <Route element={<NotFound />} />
        </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
